import BaseComponent from '../../../../../common/js/BaseComponent';

export default class Quantity extends BaseComponent {
    init(): void {
        this.initEvents();
    }

    static getTotalConditioningProduct() {
        return $('#total-conditioning');
    }

    initEvents(): void {
        this.initQuantity();
    }

    initQuantity() {
        const conditiongSelector = Quantity.getTotalConditioningProduct();
        const unitConditioningData = conditiongSelector.data('unit-conditioning');
        var conditionUnitValue = 1;
        if(unitConditioningData) {
             conditionUnitValue = parseFloat(conditiongSelector.data('unit-conditioning').replace(/,/g, ".")
            );
        }

        $('.minus').click(function () {
            const $input = $(this).parent().find('input');
            let count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count).change();
            conditiongSelector.empty().append((conditionUnitValue * count).toFixed(2));
            return false;
        });

        $('.product-count').change(function () {
            const count = parseInt($(this).val());
            if (count + 1 > parseInt($(this).data('max'))) {
                const maxCount = parseInt($(this).data('max'));
                $(this).val(maxCount).change();
                conditiongSelector.empty().append((conditionUnitValue * maxCount).toFixed(2));
            }
        });

        $('.plus').click(function () {
            const $input = $(this).parent().find('input');
            let count = parseInt($input.val()) + 1;
            if (count + 1 > parseInt($(this).data('max'))) {
                count = parseInt($(this).data('max'));
            }
            $input.val(count).change();
            conditiongSelector.empty().append((conditionUnitValue * count).toFixed(2));
            return false;
        });
    }
}
